import { ApolloClient, ApolloLink, HttpLink } from "@apollo/client";
import { RetryLink } from "@apollo/client/link/retry";
import { authToken } from "./authToken";
import { createCache } from "./createCache";

export const graphqlClient = new ApolloClient({
  cache: createCache(),
  queryDeduplication: true,
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all",
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "cache-first"
    },
    query: {
      errorPolicy: "all",
      fetchPolicy: "cache-first"
    },
    mutate: {
      errorPolicy: "all"
    }
  },
  link: ApolloLink.from([
    new RetryLink({
      attempts: {
        max: 3,
        retryIf: (error, operation) => {
          // Only notify Honeybadger in browser environment and on final failure
          if (typeof window !== "undefined" && window.Honeybadger) {
            window.Honeybadger.notify(`[GraphQL] ${error.message}`, {
              context: operation.operationName
            });
          }

          // Type guard to check if error has Apollo-specific properties
          const hasNetworkError = "networkError" in error && error.networkError;
          const hasGraphQLErrors = "graphQLErrors" in error && Array.isArray(error.graphQLErrors);

          // Only retry network errors or server-side 5xx responses
          return !!(
            hasNetworkError ||
            (hasGraphQLErrors &&
              (error as any).graphQLErrors.some((e: any) => e.extensions?.code >= 500))
          );
        }
      }
    }),
    new HttpLink({
      uri: "/graphql",
      credentials: "include",
      headers: { "X-CSRF-Token": authToken() }
    })
  ])
});
